import React from 'react';
import { Link } from 'react-router-dom';

function formatPrice(p) {
  const n = Number(p);
  if (Number.isNaN(n)) return '';
  return `$${n.toFixed(2).replace(/\.00$/, '')}`;
}

function buildTeaser(pricing) {
  if (!pricing || pricing.length === 0) return '';
  const sortedByPrice = [...pricing].sort((a, b) => Number(a.price) - Number(b.price));
  if (pricing.length === 1) {
    const p = sortedByPrice[0];
    return `${p.durationMinutes} min · ${formatPrice(p.price)}`;
  }
  const durations = pricing.map((p) => p.durationMinutes);
  const minDur = Math.min(...durations);
  const maxDur = Math.max(...durations);
  return `${minDur}–${maxDur} min · from ${formatPrice(sortedByPrice[0].price)}`;
}

export default function ServiceCard({ service }) {
  const teaser = buildTeaser(service.pricing);
  const initial = (service.name || '?').charAt(0).toUpperCase();
  return (
    <Link to={`/services/${service.slug}`} className="service-card">
      {service.image ? (
        <img className="service-card-image" src={service.image} alt={service.name} />
      ) : (
        <div className="service-card-fallback" aria-hidden="true">{initial}</div>
      )}
      <div className="service-card-body">
        <h2 className="service-card-name">{service.name}</h2>
        {service.description && <p className="service-card-desc">{service.description}</p>}
        {teaser && <p className="service-card-teaser">{teaser}</p>}
      </div>
    </Link>
  );
}
